import React from 'react'

import { CUSTOM_TEMPLATE } from '../../../_templates/Constants'
import { Label } from '../../../../../../packages/kiti/components/presentation/Text'
import {
  usePdfOptionsForm,
  usePdfOptionsFormActions
} from '../../../../../../components/pdf/options/_form/PdfOptionsFormHandler'
import LocalFileInput from '../../../../../../components/form/LocalFileInput'
import Separator from '../../../../../../packages/kiti/components/helpers/Separator'

const TemplateImportSVG = () => {
  const form = usePdfOptionsForm()
  const { handleChange } = usePdfOptionsFormActions()

  if (![CUSTOM_TEMPLATE].includes(form.template)) return false

  return (
    <>
      <Label color="black">Template (.svg)</Label>
      <LocalFileInput
        buttonLabel="Add svg"
        accept="image/*"
        onChange={handleChange('svgTemplate')}
        value={form.svgTemplate}
      />
      <Separator weight={4} />
    </>
  )
}

export default TemplateImportSVG
